import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

const DeleteFirmConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  firmName
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
    >
      <DialogTitle>
        {t('mailTemplate.campaigns.dashboard.firmRow.deleteFirmConfirmTitle')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('mailTemplate.campaigns.dashboard.firmRow.deleteFirmConfirmMessage', { firmName })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('mailTemplate.campaigns.dashboard.firmRow.deleteFirmConfirmCancel')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          {t('mailTemplate.campaigns.dashboard.firmRow.deleteFirmConfirmDelete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteFirmConfirmDialog
